module.exports = __webpack_public_path__ + "static/media/galerija_2021 (23).2b6d7ce0.jpg";